import React, { Component } from 'react';
import { Bert } from 'meteor/themeteorchef:bert';
import PropTypes from 'prop-types';
import { find, orderBy } from 'lodash';
import { Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';

import AnnotationTemplatesCollection from '../../../api/AnnotationTemplates/AnnotationTemplates';

import handleErrorInClient from '../../../modules/handle-error-in-client';
import methodPromise from '../../../modules/method-promise-wrapper';

import Loading from '../../components/Loading';
import AnnotationTemplates from '../../pages/AnnotationTemplates';
import ViewAnnotationTemplate from '../../pages/ViewAnnotationTemplate';

const ASCENDENT = 'asc';
const DESCENDENT = 'desc';

class AnnotationTemplatesContainer extends Component {
  state = {
    selectedTemplate: '',
    sort: true
  };

  componentDidMount() {
    const { changeVideoEditorContainerStateProperty } = this.props;
    changeVideoEditorContainerStateProperty('isTrackUpdated', false);
  }

  componentWillUnmount() {
    this.handleChangeSelectedTemplate();
  }

  trashAnnotationTemplate = async annotationTemplateId => {
    const { selectedTemplate } = this.state;
    if (selectedTemplate === annotationTemplateId) {
      this.handleChangeSelectedTemplate();
    }
    try {
      await methodPromise('annotationTemplates.softDelete', annotationTemplateId);
      Bert.alert('Template Moved to Trash', 'warning');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  restoreAnnotationTemplate = async annotationTemplateId => {
    const { selectedTemplate } = this.state;
    if (selectedTemplate === annotationTemplateId) {
      this.handleChangeSelectedTemplate();
    }
    try {
      await methodPromise('annotationTemplates.restore', annotationTemplateId);
      Bert.alert('Template Restored', 'success');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  deleteAnnotationTemplate = async annotationTemplateId => {
    const { selectedTemplate } = this.state;
    if (selectedTemplate === annotationTemplateId) {
      this.handleChangeSelectedTemplate();
    }
    try {
      await methodPromise('annotationTemplates.hardDelete', annotationTemplateId);
      Bert.alert('Template Deleted', 'danger');
    } catch (error) {
      handleErrorInClient(error);
    }
  };

  handleChangeSelectedTemplate = (selectedTemplate = '') => {
    this.setState(prevState => {
      if (prevState.selectedTemplate === selectedTemplate) {
        return { selectedTemplate: '' };
      }
      return { selectedTemplate };
    });
  };

  handleSort = () => this.setState(prevState => ({ sort: !prevState.sort }));

  render() {
    const {
      loading,
      annotationTemplates,
      deletedAnnotationTemplates,
      totalCount,
      deletedCount,
      history,
      match,
      isVideoEditor,
      updatedVideo,
      updateVideoProperty
    } = this.props;
    const { selectedTemplate, sort } = this.state;
    const sortedAnnotationTemplates = orderBy(
      annotationTemplates,
      ['name'],
      [sort ? ASCENDENT : DESCENDENT]
    );

    const tableProps = {
      history,
      match,
      annotationTemplates: sortedAnnotationTemplates,
      deletedAnnotationTemplates,
      totalCount,
      deletedCount,
      trashAnnotationTemplate: this.trashAnnotationTemplate,
      restoreAnnotationTemplate: this.restoreAnnotationTemplate,
      deleteAnnotationTemplate: this.deleteAnnotationTemplate,
      selectedTemplate,
      changeSelectedTemplate: this.handleChangeSelectedTemplate,
      isVideoEditor,
      updatedVideo,
      updateVideoProperty,
      handleSort: this.handleSort,
      sort
    };
    const annotationTemplate = find(annotationTemplates, item => item._id === selectedTemplate);
    if (loading) {
      return <Loading />;
    }
    return (
      <>
        <Row noGutters>
          <Col xs={6} className="pr-1">
            <AnnotationTemplates {...tableProps} />
          </Col>
          <Col xs={6} className="pl-1">
            <ViewAnnotationTemplate
              selectedTemplate={selectedTemplate}
              annotationTemplate={annotationTemplate}
              history={history}
              match={match}
              readOnly={isVideoEditor}
              trashAnnotationTemplate={this.trashAnnotationTemplate}
            />
          </Col>
        </Row>
      </>
    );
  }
}

AnnotationTemplatesContainer.defaultProps = {
  isVideoEditor: false,
  updatedVideo: {},
  changeVideoEditorContainerStateProperty: () => {},
  updateVideoProperty: () => {}
};

AnnotationTemplatesContainer.propTypes = {
  annotationTemplates: PropTypes.array.isRequired,
  deletedAnnotationTemplates: PropTypes.array.isRequired,
  deletedCount: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired,
  isVideoEditor: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  totalCount: PropTypes.number.isRequired,
  updatedVideo: PropTypes.object,
  changeVideoEditorContainerStateProperty: PropTypes.func,
  updateVideoProperty: PropTypes.func
};

export default withTracker(({ isAdmin }) => {
  let subscription;
  if (isAdmin) {
    subscription = Meteor.subscribe('annotationTemplates');
  } else {
    subscription = Meteor.subscribe('annotationTemplates.usersView');
  }
  return {
    loading: !subscription.ready(),
    annotationTemplates: AnnotationTemplatesCollection.find({ deleted: { $eq: 'no' } }).fetch(),
    deletedAnnotationTemplates: AnnotationTemplatesCollection.find({
      deleted: { $ne: 'no' }
    }).fetch(),
    totalCount: AnnotationTemplatesCollection.find({ deleted: { $eq: 'no' } }).count(),
    deletedCount: AnnotationTemplatesCollection.find({ deleted: { $ne: 'no' } }).count()
  };
})(AnnotationTemplatesContainer);
